import request from "../../../util/SuperagentUtils";
import { formatDateMMDDyyyy } from "../../../util/DateUtils";
import { adminSpaceUsageReportEndpoints } from "../../api-endpoints";
import { MomentInput } from "moment";

type AdminSpaceUsageSummaryParams = {
  startDate?: MomentInput;
  endDate?: MomentInput;
  locationId?: string;
};

/**
 * Platform-wide overage totals for a period.
 *
 * The endpoint is already rendered by `AdminSpaceUsageReport` through the
 * generic `useGetBoundReportSummary` hook, so its response shape
 * (`SpaceUsageSummary`) is verified by a live consumer. This module exists
 * because that hook cannot be called outside a component.
 */
export const requestAdminSpaceUsageSummary = (searchParams: AdminSpaceUsageSummaryParams) => {
  const { startDate, endDate, locationId } = searchParams;
  const params = new URLSearchParams();

  if (startDate) params.append("startDate", formatDateMMDDyyyy(startDate));
  if (endDate) params.append("endDate", formatDateMMDDyyyy(endDate));
  if (locationId) params.append("locationId", locationId);

  return request.get(`${adminSpaceUsageReportEndpoints.summary}?${params.toString()}`);
};
